import React from "react";
import { PiCaretRightBold } from "react-icons/pi";
import { Link } from "react-router-dom";
import { FiPhone } from "react-icons/fi";
import { MdOutlineEmail, MdOutlineLocationOn } from "react-icons/md";

const galleryImages = [
  { src: "/1a.jpg", alt: "Salon gallery 1" },
  { src: "/2.jpg", alt: "Salon gallery 2" },
  { src: "/3.jpg", alt: "Salon gallery 3" },
  { src: "/4.jpg", alt: "Salon gallery 4" },
  { src: "/5b.jpg", alt: "Salon gallery 5" },
  { src: "/6b.jpg", alt: "Salon gallery 6" },
  { src: "/00.jpg", alt: "Salon gallery 7" },
  { src: "/01.jpg", alt: "Salon gallery 8" },
];

const importantLinks = [
  { to: "/for-you", label: "For You" },
  { to: "/about", label: "About us" },
  { to: "/contact-us", label: "Contact" },
  { to: "/hair-guide", label: "Hair Guide" },
];

const SectionDivider = () => (
  <div className="flex items-center gap-1 my-2">
    <div className="w-[40px] bg-primary h-[3px]" />
    <div className="w-[20px] bg-gold-bar h-[3px] rounded-full shadow-[0_0_8px_rgba(212,175,55,0.6)]" />
  </div>
);

export default function Footer() {
  return (
    <footer className="w-full bg-black" id="home">
      <div className="max-w-[1440px] mx-auto py-12 sm:py-16 px-6 sm:px-[5%]">
        <div className="grid lg:grid-cols-2 grid-cols-1 lg:gap-10 gap-12">
          <div className="flex flex-col gap-10">
            <div>
              <Link to="/">
                <img
                  className="w-[140px]"
                  src="/glowlogo.png"
                  alt="GlowWithKindness logo"
                />
              </Link>
              <div className="flex flex-col gap-3 mt-5">
                <div className="flex items-start gap-2">
                  <MdOutlineLocationOn className="text-[22px] gold-shine-icon shrink-0 mt-0.5" />
                  <h6 className="sm:text-sm text-xs text-white/50 font-medium">
                    2650 Midway Rd Unit 140 & 240 Carrollton, TX 75006 United
                    States
                  </h6>
                </div>
                <div className="flex items-center gap-2">
                  <FiPhone className="text-[20px] gold-shine-icon shrink-0" />
                  <h6 className="sm:text-sm text-xs text-white/50 font-medium">
                    (469) 670-0124
                  </h6>
                </div>
                <div className="flex items-center gap-2">
                  <MdOutlineEmail className="text-[20px] gold-shine-icon shrink-0" />
                  <h6 className="sm:text-sm text-xs text-white/50 font-medium">
                    inquiry@glowwithkidness.com
                  </h6>
                </div>
              </div>
              <div className="mt-6 flex flex-col gap-2 text-white">
                <h6 className="text-[20px] font-semibold bg-gold-shine bg-clip-text text-transparent w-fit">
                  Open Hours
                </h6>
                <h6 className="font-medium text-sm sm:text-base">
                  Tuesday to Sunday 08:00am - 08:00pm
                </h6>
              </div>
            </div>

            <div>
              <h4 className="text-[22px] text-white">CONNECT WITH US</h4>
              <SectionDivider />
              <h5 className="text-white/50 text-sm mt-4">
                Enter your email address — we promise not to spam you.
              </h5>
              <div className="w-full h-[50px] bg-[#273036] mt-4">
                <input
                  type="text"
                  className="w-full h-full bg-transparent outline-none px-5 placeholder:text-sm text-white"
                  placeholder="Your email"
                />
              </div>
              <button className="bg-gold-shine text-black px-8 py-3 mt-4 font-semibold text-sm shadow-[0_4px_16px_rgba(212,175,55,0.4)] hover:brightness-110 transition-all">
                SUBSCRIBE
              </button>
            </div>
          </div>

          <div className="flex flex-col gap-10">
            <div>
              <h4 className="text-[22px] text-white">IMPORTANT LINKS</h4>
              <SectionDivider />
              <div className="mt-6 flex gap-3 flex-col">
                {importantLinks.map((link) => (
                  <Link to={link.to} key={link.to}>
                    <div className="flex items-center gap-1 group">
                      <PiCaretRightBold className="gold-shine-icon" />
                      <h6 className="text-sm uppercase text-white/50 group-hover:text-gold transition-colors">
                        {link.label}
                      </h6>
                    </div>
                  </Link>
                ))}
              </div>
            </div>

            <div>
              <h4 className="text-[22px] text-white">Gallery</h4>
              <SectionDivider />
              <div className="grid grid-cols-4 gap-2 mt-6">
                {galleryImages.map((img, idx) => (
                  <a
                    key={idx}
                    href="https://www.instagram.com/glowwithkindness/"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="aspect-square overflow-hidden"
                  >
                    <img
                      src={img.src}
                      alt={img.alt}
                      className="w-full h-full object-cover hover:scale-105 transition-transform"
                    />
                  </a>
                ))}
              </div>
            </div>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-white/10 flex flex-col sm:flex-row justify-between items-center gap-2">
          <h6 className="text-xs text-white/40">
            © {new Date().getFullYear()} GlowWithKindness. All rights reserved.
          </h6>
          <h6 className="text-xs text-white/40">
            Crafted with care for every client.
          </h6>
        </div>
      </div>
    </footer>
  );
}
